import { observer } from 'mobx-react-lite'
import { useJobDetailsViewModel } from '@/features/jobs/details/JobDetailsView'
import { TaxJobDetailsViewModel } from '@/features/jobs/details/tax-type/TaxJobDetailsViewModel'
import { TaxJobBillingTab } from '@/features/jobs/details/tax-type/components/TaxJobBilling'
import { PageLayout } from '../../components/PageLayout'
import { BillingSummarySectionContainer } from '@/features/jobs/details/components/BillingSummarySection'
import { JobScopeChangesSectionContainer } from '@/features/jobs/details/components/JobScopeChangesSection'
import { useActivation } from '@/hooks/view-model-hooks'
import { BillingContactSection } from '@/features/billing/components/BillingContactSection'
import { BillingPaymentHistorySectionContainer } from '@/features/jobs/details/components/BillingPaymentHistorySection'

export default observer(function BillingTab() {
  const vm = useJobDetailsViewModel()

  useActivation(vm.jobBillingDetailsVm)

  if (vm.typeVm instanceof TaxJobDetailsViewModel) {
    return <TaxJobBillingTab />
  }

  return <DefaultJobBillingTab />
})

const DefaultJobBillingTab = observer(() => {
  const vm = useJobDetailsViewModel()

  return (
    <PageLayout
      asideTop={<BillingSummarySectionContainer vm={vm.jobBillingDetailsVm} />}
    >
      <JobScopeChangesSectionContainer vm={vm.jobScopeChangesDisplayVm} />
      <BillingPaymentHistorySectionContainer vm={vm.jobBillingDetailsVm} />
      <BillingContactSection />
    </PageLayout>
  )
})
